import {
  authApi,
  type PasswordChangeRequest,
  type PasswordChangeWithTokenBody,
  type PasswordResetTokenBody,
  type PasswordResetTokenParams,
  type WeizmannLoginRequest,
  type WeizmannOauth2LoginRequest,
} from '@mathflat/domain/Auth'
import type { Student } from 'src/dto'

import type Controller from './Controller'

const INITIAL_PIN = '123456'

class AuthController implements Controller {
  adapter = {}

  async resetMyPassword(password: PasswordChangeRequest) {
    await authApi.changePassword(password, { mp_event_name: 'T21-03_비번수정_API' })
  }

  async findPasswordFirstStep(params: PasswordResetTokenBody) {
    await authApi.requestPasswordResetToken(params, { mp_event_name: 'T10-03_비번재설정1_API' })
  }

  async findPasswordSecondStep(params: PasswordResetTokenParams) {
    await authApi.checkPasswordResetToken(params, { mp_event_name: 'T10-04_비번재설정2_API' })
  }
  async findPasswordThirdStep(params: PasswordChangeWithTokenBody) {
    await authApi.changePasswordWithResetToken(params, { mp_event_name: 'T10-05_비번재설정3_API' })
  }
  async resetStudentPassword(studentId: Student['id']) {
    await authApi.resetPassword(
      {
        type: 'STUDENT',
        newPassword: INITIAL_PIN,
        newPasswordCheck: INITIAL_PIN,
        relationId: studentId,
      },
      { mp_event_name: 'T51-04_학생학부모비번수정_API' },
    )
  }
  async resetParentPassword(parentId: Student['loginId']) {
    await authApi.resetPassword(
      {
        type: 'PARENT',
        newPassword: INITIAL_PIN,
        newPasswordCheck: INITIAL_PIN,
        relationId: parentId,
      },
      { mp_event_name: 'T51-04_학생학부모비번수정_API' },
    )
  }

  async weizmannLogin(requestDto: WeizmannLoginRequest) {
    return authApi.loginWithWeizmannLegacy(requestDto)
  }

  async weizmannOauth2Login(requestDto: WeizmannOauth2LoginRequest) {
    return authApi.loginWithWeizmann(requestDto)
  }
}

export const authController = new AuthController()
